<div class="TableOfContent" [class.TableOfContent--sticky]="isSticky" [class.TableOfContent--notSticky]="!isSticky" [class.TableOfContent--large]="!isMobile">
  <h2>Content</h2>
  <ul [class.MoreButtonIsDisplayed]="showMoreButton" [ngClass]="{'TableOfContent-oversized': docData.sections.length > 15}">
    <li *ngFor="let section of docData.sections" [ngClass]="">
      <a pageScroll [pageScrollDuration]="0" href="#{{section.uuid}}" *ngIf="section.title">{{section.title | truncateText:90}}</a>
    </li>
  </ul>
  <div class="ShowMore" *ngIf="showMoreButton && !isSticky" (click)="showFullToc()">Show more...</div>
</div>